import Link from 'next/link'

// 服务端直出的顶栏:外观对齐 Layout 顶栏,但全部是真 <a href>,爬虫能顺着走。
// 客户端加载完 Layout 后被真正的导航(带登录态)替换。
export const NAV_LINKS: [string, string][] = [
  ['首页', '/'],
  ['比赛列表', '/match'],
  ['赛事库', '/events'],
  ['资讯', '/news'],
  ['规则', '/rules'],
  ['百科', '/baike'],
  ['复式发牌机', '/fushiji'],
  ['使用手册', '/manual'],
  ['办赛指南', '/guide'],
]

const StaticNav = ({ transparent = false }: { transparent?: boolean }) => (
  <nav
    id="header"
    aria-label="主导航"
    className={`fixed inset-x-0 top-0 z-50 m-auto flex h-16 w-full items-center justify-between text-white ${transparent ? 'bg-transparent' : 'bg-ink'}`}
  >
    <div className="m-auto flex w-full max-w-[2048px] items-center justify-between px-4">
      <Link href="/" className="flex shrink-0 items-center gap-2 text-white">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/lingti-gd-logo.png" alt="灵缇赛事系统" className="h-10 w-10 shrink-0" />
        <span className="shrink-0 font-serif text-lg font-bold text-gold">灵缇赛事系统</span>
      </Link>
      <div className="hidden items-center gap-6 lg:flex">
        {NAV_LINKS.map(([label, href]) => (
          <Link key={href} href={href} className="shrink-0 text-base text-white">
            {label}
          </Link>
        ))}
        <Link href="/login" className="shrink-0 text-base text-white">
          登录/注册
        </Link>
      </div>
      <Link href="/login" className="text-xl text-white lg:hidden">
        登录/注册
      </Link>
    </div>
  </nav>
)

export default StaticNav
